import { Mandate, SuggestedPaymentPartner } from 'models/Mandate';
import { Transaction } from 'models/Transaction';
import { PaymentPartnerOption } from 'components/PaymentPartner/PaymentPartnerRadioGroup';

export const getPaymentPartnerId = (
  suggestedPaymentPartners: SuggestedPaymentPartner[],
  paymentPartnerId: string | null
) => {
  const paymentPartner = suggestedPaymentPartners.find(partner => partner.id === paymentPartnerId);
  return paymentPartner?.id ?? '';
};

type Mandates = Record<string, Mandate[]>;

export const removeAdditionalFields = (mandateGroups: Mandates, fieldsToRemove: string[]) =>
  Object.entries(mandateGroups).reduce<Mandates>((accumulator, [groupName, mandates]) => {
    accumulator[groupName] = mandates.map(mandate => {
      return {
        ...mandate,
        additionalFields: mandate.additionalFields.filter(
          item => !fieldsToRemove.includes(item.name)
        )
      };
    });

    return accumulator;
  }, {});

export const analyzeTransactions = (transactions: Transaction[]) => {
  let transactionDetails = null;

  if (transactions.length === 0) {
    return transactionDetails;
  }

  const transaction = transactions[0];
  const haveDifferentAmounts = transactions.some(
    currentValue => currentValue.amount !== transaction.amount
  );

  if (!haveDifferentAmounts) {
    transactionDetails = transaction;
  }

  return transactionDetails;
};

export const getPaymentPartnerRadioOptions = (
  data: SuggestedPaymentPartner[]
): PaymentPartnerOption[] =>
  data.map(item => ({ label: item.name, value: item.id, address: item.address }));
